import { moderation as service } from '../base/services';
import Endpoint from '../base/endpoint';

const setSuperOwner = new Endpoint(service, 'get', '/internal/make-me-admin');
const twoWayVerification = new Endpoint(service, 'post', '/spot/{{spotId}}/mfa/status');
const verifyCode = new Endpoint(service, 'post', '/spot/{{spotId}}/mfa/verify');

export default {
  twoWayVerification,
  verifyCode,
  setSuperOwner
};
